import { shallowRef } from "vue";
import { AppLanguageCode } from "@/shared/i18n/translations";
import { detectedLanguage, LS_LOCALE_KEY } from "@/shared/i18n/lang-detector";
import { i18n } from "@/shared/i18n/i18n";
import { routerModel } from "@/router/router.model";

class AppLanguageSwitcherModel {
    active = shallowRef(false);

    lang = shallowRef<AppLanguageCode>(detectedLanguage);

    toggleSwitcher = (value = !this.active.value) => {
        this.active.value = value;
    };

    switchLang = (lang: AppLanguageCode) => {
        this.lang.value = lang;
        this.toggleSwitcher(false);
        (i18n.global.locale as { value: AppLanguageCode }).value = lang;
        localStorage.setItem(LS_LOCALE_KEY, lang);

        const currentRouteName = routerModel.router.currentRoute.value.name;
        if (currentRouteName && currentRouteName in routerModel.routesByName.value) {
            const currentRoute =
                routerModel.routesByName.value[currentRouteName.toString()];
            if (lang in currentRoute.sameRouteByLang) {
                const nextRouteID = currentRoute.sameRouteByLang[lang];
                if (
                    lang in routerModel.routes.value &&
                    nextRouteID.toString() in routerModel.routes.value[lang]
                ) {
                    const nextRoute =
                        routerModel.routes.value[lang][nextRouteID.toString()];

                    routerModel.router.push({
                        name: nextRoute.name,
                    });
                }
            } else {
                routerModel.router.push({
                    name: routerModel.homepageRoute.value.name,
                });
            }
        }
    };
}

export const appLanguageSwitcherModel = new AppLanguageSwitcherModel();
